import {efdocConstants, sentConstants} from "../../constants";

const initialState = {
  efdocList: {},
  certboxOrgList: {},
  certboxReadingList: {},
  isLoading: false,
  isFailure: false,
  isDelete: false,
  isSubmit: false,
  isSubDoc: false,
  isReceive: false,
  isReading: false,
  showPwdPopup: false,
  receiverList: [],
  pcrlInfo: {},
  crtfInfo: {},
  readingInfo: {}
}

export default function efdoc(state = initialState, action) {
  switch (action.type) {
    /***********
     수신함 검색조건 변경
     ************/
    case efdocConstants.SELECT_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload
      }

    /*********
     수신함 목록 조회
     **********/
    case efdocConstants.EFDOC_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case efdocConstants.EFDOC_SUCCESS:
    
      return {
        ...state,
        efdocList: action.response.data?.payload,
        isDelete: false,
        isReject: false,
      }
    case efdocConstants.EFDOC_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

      /*********
     수신함 원본 목록 조회
     **********/
    case efdocConstants.EFDOC_ORG_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case efdocConstants.EFDOC_ORG_REQUEST:
      return {
        ...state,
        certboxOrgList: action.response.data?.payload,
        isDelete: false,
        isReject: false,
      }
    case efdocConstants.EFDOC_ORG_REQUEST:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }
      
    /***********
     증명서 수신함 히스토리 관리
     ************/
    case efdocConstants.EFDOC_HISTORY:
      return {
        ...state,
        history: action.payload
      }

    /*********
     증명서 PDF BASE64STRING 조회
     **********/
    case efdocConstants.PDF_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailure: false,
      }
    case efdocConstants.PDF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pdfString: action.response.data
      }
    case efdocConstants.PDF_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     PDF 호출 init 처리
     ************/
    case efdocConstants.INIT_FLAG_REQUEST:
      return {
        ...state,
        pdfString: null
      }

    /***********
     상태관련 state 초기화
     ************/
    case efdocConstants.CLEAR_REQUEST:
      return {
        ...state,
        isFailure: false,
        isDelete: false,
        isSubmit: false,
      }

    /*********
     증명서 첨부파일 다운로드
     **********/
    case efdocConstants.FILE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case efdocConstants.FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isFile: true
      }
    case efdocConstants.FILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFile: false
      }
      default:
        return state
  }
}
